import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

export const RequireCustomer: React.FC = () => {
  const token = useAppSelector((s) => s.customerAuth.token);
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
};

export default RequireCustomer;
